import { Model } from 'survey-core';

import { useAPI } from 'context/api-context';
import { useLocale } from 'context/locale-context';
import { useSettings } from 'context/settings-context';
import { useClinics } from 'context/clinics-context';

import { savePdf } from './DownloadPDF.utils';

import { LogoResponse, Questionnaire as QuestionnaireInterface } from 'shared/interfaces';
import { SurveyPDFType } from './DownloadPDF.types';

export const useDownloadPDF = (
  id: number,
  firstName: string,
  lastName: string,
  birthDate: string,
  type: SurveyPDFType,
  returnAsFile: boolean
) => {
  const { fetchAPI } = useAPI();
  const { getLocaleOption, locale } = useLocale();
  const { showToast } = useSettings();
  const { assignedClinic } = useClinics();

  const downloadPDF = async () => {
    const url = type === 'layout' ? 'surveys' : 'usersurveys';
    const questionnaire: QuestionnaireInterface = await fetchAPI(`/${url}/${id}/`, {
      withToken: true,
    });

    const logo: LogoResponse = await fetchAPI(
      `/clinics/${assignedClinic?.id}/logofile/`,
      {
        withToken: true,
      }
    );

    if (!questionnaire || !questionnaire.surveyJSJson) {
      return showToast({
        type: 'error',
        title: getLocaleOption('error'),
        text: getLocaleOption('somethingWentWrong'),
      });
    }

    const survey = new Model(questionnaire.surveyJSJson);
    survey.locale = locale;

    const answers = questionnaire.answers ? JSON.parse(questionnaire.answers) : '';
    const name = firstName + ' ' + lastName;
    const nameTitle = getLocaleOption('name');
    const birthDateTitle = getLocaleOption('birthday');
    const logoBase64 = logo.data ? `data:image/png;base64,${logo.data}` : null;

    const result = await savePdf(
      JSON.parse(questionnaire.surveyJSJson),
      answers,
      survey.locale,
      type,
      nameTitle,
      name,
      birthDateTitle,
      birthDate,
      logoBase64,
      returnAsFile
    );

    return result;
  };

  return { downloadPDF };
};
